<template>
  <div class="home" v-if="showAppCenter">
    <div class="border"></div>
    <div class="cont">
      <ul>
        <li>
          <h4>我的应用</h4>
          <van-grid :border="false" square>
            <van-grid-item v-for="item in dataList" :key="item.id" @click="toApp(item.pageUrlH5, item.appId, item.appCode, item.appName)">
              <img :src="getImageStream(item.appIcon)" alt="" style="width:40px;height:40px">
              <p style="text-align:center;">{{item.appName}}</p>
            </van-grid-item>
          </van-grid>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {getImageStream} from '@/utils/index'
export default {
  data () {
    return {
      dataList: [],
      menuList: [],
      showAppCenter: false
    }
  },
  created () {
    this.getBackToken()
  },
  methods: {
    toApp (url, appId, code, name) {
      if (url.indexOf('/') == 0) {
        this.$router.push(url)
      } else if (url.indexOf('http') == 0) {
        if (code == 'county_form' || code == 'uht_county_form') {
          this.getCountyFormCode(url, name, appId, code)
        }
        this.$router.push({path: '/appSSO', query: {url, appId, code, name}})
      }
    },
    getCountyFormCode (url, name, appId, code) {
      this.$http({
        url: this.$http.adornUrl('/wxapp/sys/user/getCountyFormCode'),
        method: 'post'
      }).then(({data}) => {
        if (data) {
          let countyFormCode = data.code
          this.$nextTick(() => {
            this.$router.push({path: '/appSSO', query: {url, appId, code, name, countyFormCode}})
          })
        }
      })
    },
    getImageStream (e) {
      return getImageStream(e,process.env.VUE_APP_BASE_BACK_URL)
    },
    getBackToken () {
      this.$http({
        url: this.$http.adornUrl('/wxapp/application/appauth'),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.$globalData.backToken = data.token
          this.getList()
        } else {
          this.$message.error(data.msg)
          this.errorMsg = data.msg
        }
      })
    },
    getList () {
      this.$httpBack({
        url: this.$httpBack.adornUrl('/app/application/info/myApp'),
        method: 'get',
        params: this.$httpBack.adornParams({
          'page': 1,
          'limit': -1
        })
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.showAppCenter = true
          let list = []
          data.page.list.forEach(item => {
            if(item.pageUrlH5 !== '/') {
              list.push(item)
            }
          })
          this.getWgggMenuList(list)
        } else {
          this.dataList = []
        }
      })
    },
    // 获取网格果果菜单
    getWgggMenuList(list) {
      this.$http({
        url: this.$http.adornUrl('/wxapp/nav'),
        method: 'get',
        params: this.$http.adornParams({
          clientType: 2
        })
      }).then(({data}) => {
        if(data && data.code === 0) {
          data.menuList.map(item => {
            if(item.list && item.list.length > 0) {
              item.list.map(it => {
                  this.menuList.push(it)
              })
            }
          })
          this.menuList.map(item => {
            if(item.code && item.code.indexOf('&') != -1) {
              item.code = item.code.replace('wggg&','')
            }
          })
          let tepArrA = []
          let tepArrB = []
          list.map((item,index) => {
            if(item.appCode == 'sjgl_xcjl') {
              tepArrA.push(item)
            }else if(item.appCode == 'sjgl_wtjl') {
              tepArrA.push(item)
            }else if(item.appCode == ' sjgl_sgzf_zfjl') {
              tepArrA.push(item)
            }else if(item.appCode == 'sjgl_bxjl') {
              tepArrA.push(item)
            }else if(item.appCode == 'yy_bszn') {
              tepArrA.push(item)
            }else if(item.appCode == 'sqgg') {
              tepArrA.push(item)
            }else if(item.appCode == 'sjgl_hdjl') {
              tepArrA.push(item)
            }else if(item.appCode == 'wjda') {
              tepArrA.push(item)
            }else {
              tepArrB.push(item)
            }
          })
          tepArrA = tepArrA.filter(item => {
            return this.menuList.every(it => {
              return item.appCode != it.code
            })
          })
          this.dataList = tepArrB.concat(tepArrA)
          // 过滤相同的
          // this.dataList = list.filter(item => {
          //   return this.menuList.every(it => {
          //     return item.appCode != it.code
          //   })
          // })
        }else {
          this.menuList = []
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .van-grid-item__content {
  padding: 0;
}
.home {
  .fr {
    float: right !important;
  }
  .cont {
    overflow: hidden;
    // padding: 40px;
    background-color: #fff;
    ul {
      width: 100%;
      li {
        h4 {
          font-size: 30px;
          margin: 30px 44px;
          // margin-bottom: 30px;
        }
        .form-color {
          border-radius: 20px;
          position: relative;
          width: 100px;
          height: 100px;
        }
        .form-icon {
          color: #fff;
          font-size: 58px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        p {
          font-size: 26px;
        }
      }
    }
  }
}
.red {
  background-image: linear-gradient(135deg, #FF6161, #F53232);
}
.orange {
  background-image: linear-gradient(135deg, #F58166, #FC5B23);
}
.green {
  background-image: linear-gradient(135deg, #48DA97, #19BB65);
}
.blue {
  background-image: linear-gradient(135deg, #4C97FF, #2456EB);
}
.wathet {
  background-image: linear-gradient(135deg, #16B7FD, #2B95E7);
}
.light-orange {
  background-image: linear-gradient(135deg, #FFE36F, #FF7118);
}
.border {
  width: 100%;
  height: 20px;
  background-color: #f1f2f7;
}
</style>
